import { cloneDeep, set } from "lodash";

export const createSetter =
  (...propPath) =>
  (state, { value }) =>
    set(cloneDeep(state), propPath, value);

export const createReducer =
  (defaultState, handler) =>
  (state = defaultState, { type, ...rest }) => {
    if (handler[type]) {
      return handler[type](state, { ...rest });
    }

    return state;
  };
